import { render, staticRenderFns } from "./OrderFeedbackAdd.vue?vue&type=template&id=254d4d71&scoped=true"
import script from "./OrderFeedbackAdd.vue?vue&type=script&lang=js"
export * from "./OrderFeedbackAdd.vue?vue&type=script&lang=js"
import style0 from "./OrderFeedbackAdd.vue?vue&type=style&index=0&id=254d4d71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d4d71",
  null
  
)

export default component.exports